module.exports = __webpack_public_path__ + "img/stamp.f6208d87.png";